module.exports = __webpack_public_path__ + "img/Micron-logo_white.6cd06a21.svg";